<template>
  <app-page-container :showNav="true" :clean="true" :background="'calendar'">
    <BlockExcludeModal
      v-if="blocking || excluding"
      :isExcluded="isExcluded"
      :displayName="firstName"
      :blocking="blocking"
      :excluding="excluding"
      :blockingInProcess="blockingInProcess"
      :excludingInProcess="excludingInProcess"
      @block="block"
      @exclude="exclude"
    />
    <BlockExcludeSuccessModal
      v-if="unexcludingComplete || blockingComplete || excludingComplete"
      :displayName="firstName"
      :unexcludingComplete="unexcludingComplete"
      :blockingComplete="blockingComplete"
      :excludingComplete="excludingComplete"
      @block="block"
      @exclude="exclude"
    />
    <div v-if="exists && loaded" class="profileContainer">
      <!-- <MessengerModal v-if="messengerOpen" /> -->
      <ProfileHeader
        v-if="loaded && profileOwnerID"
        :profileOwnerID="profileOwnerID"
        :userID="user._id"
        :currentUserIsOwner="currentUserIsOwner"
        :sessionCount="sessionCount"
        :profileDisplayName="profileDisplayName"
        :profileImageUrl="profileImageUrl"
        :profileUserJoinedDate="profileUserJoinedDate"
        :profileUserBio="profileUserBio"
        :connectionStatus="connectionStatus"
        :requesterID="requesterID"
        :connectionID="connectionID"
        :isExcluded="isExcluded"
        :isNick="isNick"
        :hasMedal="hasMedal"
        @unexcludingComplete="isExcluded = false"
        @updateConnectionStatus="updateConnectionStatus"
        @openMessenger="openMessenger"
      />
      <div v-if="loaded">
        <!-- v-if loaded is needed to remove the keep-alive cache when route changes, do not delete -->
        <div class="tab-list">
          <div
            v-for="(blah, i) in currentUserIsOwner ? tabLengthForOwn : tabLengthForOther"
            :key="tabs[i].name"
            :class="['tab-button', { active: currentTab.name === tabs[i].name }]"
            :disabled="currentTab.name === tabs[i].name"
            @click="changeTab(i)"
          >
            {{ tabs[i].name }}
          </div>
        </div>
        <keep-alive>
          <component
            :is="currentTab.component"
            :userID="user._id"
            :profileOwnerID="profileOwnerID"
            :currentUserIsOwner="currentUserIsOwner"
            :isProfilePremium="isProfilePremium"
          ></component>
        </keep-alive>
      </div>
    </div>
    <div v-else-if="loaded && !exists">This profile does not exist.</div>
  </app-page-container>
</template>

<script>
import { mapState } from "vuex";
import AppPageContainer from "@/components/AppPageContainer";
import ProfileHeader from "./ProfileComponents/ProfileHeader";
import ProfileTabMain from "./ProfileComponents/ProfileTabMain";
import ProfileTabBadges from "./ProfileComponents/ProfileTabBadges";
import ProfileTabConnections from "./ProfileComponents/ProfileTabConnections";
import ProfileTabSent from "./ProfileComponents/ProfileTabSent";
import ProfileTabReceived from "./ProfileComponents/ProfileTabReceived";
import ProfileTabHiddenBunny from "./ProfileComponents/ProfileTabHiddenBunny";

import BlockExcludeModal from "./ProfileComponents/BlockExcludeModal.vue";
import BlockExcludeSuccessModal from "./ProfileComponents/BlockExcludeSuccessModal.vue";

import profileAPIService from "../../api/profileAPIService";

import { BadgeStore } from "../../ELYX/ELYXStore";
import BadgeMethods from "../../ELYX/Badges/BadgeMethods";

import { SharedUserUtilities } from "@shared";

function initialState() {
  return {
    loaded: false,
    exists: true,

    /* ==== tab handling ==== */

    currentTab: { name: "Main", component: "ProfileTabMain" },
    /* the stupid beautifier will fuck this up but whatever */
    tabs: [
      { name: "Overview", url: "", component: "ProfileTabMain" },
      { name: "Badges", url: "badges", component: "ProfileTabBadges" },
      { name: "Connections", url: "connections", component: "ProfileTabConnections" },
      { name: "Sent requests", url: "sent-requests", component: "ProfileTabSent" },
      { name: "Received Requests", url: "received-requests", component: "ProfileTabReceived" },
      { name: "Hidden Bunny", url: "bunny", component: "ProfileTabHiddenBunny" },
    ],
    tabLengthForOwn: 5,
    tabLengthForOther: 2,
    /* ==== connection status ==== */

    connectionID: null,
    /* allowed statuses: "nonexistent", "pending", "connected", "unconnected", "blocked" */
    connectionStatus: "nonexistent",
    requesterID: null,

    /* ==== profile header data ==== */

    sessionCount: 0,
    profileDisplayName: "",
    profileImageUrl: null,
    profileUserJoinedDate: null,
    profileUserBio: "",

    profile: null,
    isProfilePremium: false,
    viewer: null,

    connections: [],

    profileConnectionsData: null,
    viewerConnectionsData: null,

    connected: false,

    connectDataLoaded: false, // prevent showing incorrect connect buttons prematurely

    cancelingConnectRequest: false,

    isExcluded: false,
    blockingInProcess: false,
    excludingInProcess: false,
  };
}

export default {
  name: "Profile",
  data: function () {
    return initialState();
  },
  components: {
    AppPageContainer,
    ProfileHeader,
    // MessengerModal,

    ProfileTabMain,
    ProfileTabBadges,
    ProfileTabConnections,
    ProfileTabSent,
    ProfileTabReceived,
    ProfileTabHiddenBunny,

    BlockExcludeModal,
    BlockExcludeSuccessModal,
  },
  computed: {
    badges: () => BadgeStore.state.badges,

    ...mapState({
      user: (state) => state.auth.user,
      blocking: (state) => state.modals.blocking,
      excluding: (state) => state.modals.excluding,
      blockingComplete: (state) => state.modals.blockingComplete,
      excludingComplete: (state) => state.modals.excludingComplete,
      unexcludingComplete: (state) => state.modals.unexcludingComplete,
      // messengerOpen: (state) => state.messages.modalOpened,
    }),
    profileOwnerID() {
      return this.$route.params.userID;
    },
    currentUserIsOwner() {
      return this.$route.params.userID === this.user._id;
    },
    isUser() {
      return this.user._id == this.$route.params.userID;
    },
    currentTabComponent: function () {
      return "ProfileTab" + this.currentTab.toLowerCase();
    },
    firstName() {
      let string = this.profileDisplayName;
      let isLongString = false;
      if (string.length > 18) {
        isLongString = true;
      }
      string = string.replace(/ .*/, "").substring(0, 17);
      return isLongString ? string + "..." : string;
    },
    isNick() {
      return this.$route.params.userID === "60e9bb09b27e5d0015d73a2f";
    },
    hasMedal() {
      return this.badges.some((item) => item && item.badgeNr === 28);
    },
  },
  methods: {
    async cleanBeforeLeave(fromBeforeLeave = false, next = null) {
      window.removeEventListener("beforeunload", this.cleanBeforeLeave);
      /* Ensure that the buttons don't show the wrong message by
      showing the state of the previous user profile visited. */
      this.resetWindow();

      this.$store.dispatch("modals/setModalState", {
        modal: "excludingComplete",
        newState: false,
      });

      this.exists = false;
      if (fromBeforeLeave && next !== null) {
        next();
      }
    },

    resetWindow: function () {
      Object.assign(this.$data, initialState());
    },

    async initProfile() {
      const profileData = await profileAPIService.getProfileData(this.$route.params.userID);
      if (profileData !== null && profileData.connection && profileData.profile) {
        this.connectionID = profileData.connection.CID ? profileData.connection.CID : null;
        this.connectionStatus = profileData.connection.status;
        this.requesterID = profileData.connection.requesterID;

        this.sessionCount = profileData.profile.sessionCount;
        this.profileDisplayName = profileData.profile.displayName;
        this.profileImageUrl = profileData.profile.imageURL;
        this.profileUserJoinedDate = new Date(Number(profileData.profile.joined));
        this.profileUserBio = profileData.profile.bio;
        this.isProfilePremium = SharedUserUtilities.isUserPremium(profileData.profile.subscription);
        this.isExcluded = profileData.isExcluded;
        document.title = `${this.profileDisplayName} - Cofocus.one`;
      } else {
        this.exists = false;
      }

      this.setTabByURL(this.$route.params.profileTab);

      /* atm all badges are always loaded immediately and simultaneously. 
        This is ok, until we don't have more than ~ 20 badges */
      await BadgeMethods.getAllProfileBadges(this.$route.params.userID);

      this.loaded = true; // important, do not delete
    },

    /**
     * when a tab is clicked, changeTab changes the url,
     * which is watched and the watcher calls setTabByURL
     */
    changeTab(index) {
      console.log("@changeTab the data: ", index, this.tabs[index].name);
      const uri = `/profile/${this.$route.params.userID}/${this.tabs[index].url}`;
      this.$router.push({ path: uri });
      /* window.location = uri; */
    },

    setTabByURL(newTabURL) {
      if (typeof newTabURL === "undefined") {
        this.currentTab = this.tabs[0];
      } else {
        const index = this.tabs.findIndex((tab) => tab.url === newTabURL);
        if (index >= 0) {
          this.currentTab = this.tabs[index];
        }
      }
    },
    updateConnectionStatus(result) {
      this.connectionID = result.CID;
      this.connectionStatus = result.status;
      this.requesterID = result.requesterID;

      switch (result.action) {
        case "connect":
          if (result.status !== "pending" && result.status !== "connected") console.error("STATUS UPDATE FAILED, handle me");
          break;
        case "unconnect":
          if (result.status !== "unconnected") console.error("STATUS UPDATE FAILED, handle me");
          break;
        case "accept":
          if (result.status !== "connected") console.error("STATUS UPDATE FAILED, handle me");
          break;
        case "reject":
          if (result.status !== "unconnected") console.error("STATUS UPDATE FAILED, handle me");
          break;
        case "cancel":
          if (result.status !== "unconnected") console.error("STATUS UPDATE FAILED, handle me");
          break;
      }
    },

    async openMessenger() {
      await this.$store.dispatch("messages/setCurrentConversation", this.connectionID);
      this.$store.commit("messages/SET_MODAL_OPENED", true);
    },

    async delay(ms) {
      return new Promise((res) => setTimeout(res, ms));
    },

    async block() {
      this.blockingInProcess = true;
      await profileAPIService.blockUser(this.user._id, this.$route.params.userID);
      window.mixpanel.track("Block", { blockerID: this.user._id, blockedID: this.$route.params.userID });
      this.$store.dispatch("modals/setModalState", {
        modal: "blocking",
        newState: false,
      });
      this.blockingInProcess = false;
      this.$store.dispatch("modals/setModalState", {
        modal: "blockingComplete",
        newState: true,
      });
      await this.delay(2500);
      this.$store.dispatch("modals/setModalState", {
        modal: "blockingComplete",
        newState: false,
      });
      window.location = "/";
    },

    async exclude(ms) {
      this.excludingInProcess = true;
      const result = await profileAPIService.excludeUser(this.user._id, this.$route.params.userID, ms);
      window.mixpanel.track("Take break", { breakerID: this.user._id, breakedID: this.$route.params.userID, duration: ms });
      console.log(result);
      this.$store.dispatch("modals/setModalState", {
        modal: "excluding",
        newState: false,
      });
      this.excludingInProcess = false;
      this.isExcluded = true;
      this.$store.dispatch("modals/setModalState", {
        modal: "excludingComplete",
        newState: true,
      });
    },
  },
  async created() {
    window.addEventListener("beforeunload", this.cleanBeforeLeave);
    this.initProfile();
  },
  beforeRouteLeave(to, from, next) {
    this.cleanBeforeLeave(true, next);
  },
  watch: {
    "$route.params.userID": {
      handler() {
        console.log("this.$route.params: ", this.$route.params);
        this.loaded = false;
        this.resetWindow();
        this.initProfile();
      },

      immediate: true,
    },
    "$route.params.profileTab": {
      handler(newTabURL) {
        this.setTabByURL(newTabURL);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.profileContainer {
  overflow-y: scroll;
  height: 100%;
}
.tab-list {
  display: flex;
  justify-content: center;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  background: rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  margin-top: 10px;
  margin-bottom: 15px;
  padding: 5px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
}
.tab-button {
  font-size: 16px;
  font-weight: 500;
  margin-right: 5px;
  padding: 10px 15px;
  border-radius: 10px;
  cursor: pointer;
}
.tab-button:hover,
.tab-button.active {
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgba(255, 255, 255, 0.8) !important;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}

.profile .actions:hover .cancel {
  display: flex !important;
}

.profile .actions .cancel {
  margin-left: auto;
  border-radius: 360px;
  padding: 5px 8px;
  font-weight: 700;
  position: absolute;
  right: 15px;
  box-sizing: border-box;
  background-color: #d4d4d4f0;
  width: 21px;
  height: 21px;
  color: #2d2d2d;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  text-align: center;
  padding-top: 2px;
  z-index: 9999;
  font-family: "Nunito", sans-serif;
  outline: none;
  border: none;
  cursor: pointer;
  top: 4px;
  display: none;
}

.profile .actions .cancel:hover {
  background-color: #868a8c;
}

.profileName {
  font-size: 25px;
  margin-top: 10px;
}

.links {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

.viewProfile,
.newRoom {
  font-size: 18px;
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
  letter-spacing: 0.5px;
  background-color: #eaeaea;
  color: #2d2d2d;
  padding: 6px 14px;
  font-weight: 700;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.2s ease;
}

.viewProfile:hover,
.newRoom:hover {
  background-color: #b7bcc194;
}

.viewProfile {
  color: #222;
}

.newRoom {
  color: #5600ff;
}

/* .newRoom {
  background-color: #000000;
  color: white;
}

.newRoom:hover {
  background-color: #333;
} */

.myrooms-sub {
  margin-top: 5px;
}

.rooms {
  width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  /* background-color: #f3f4f7eb; */
  border-radius: 4px;
}
</style>
